import styled from 'styled-components';

export const Unitsblock = styled.div `

  background: #f5f5f7;
  height: 80vh;
  padding-top: 1em;
  display: flex;
  justify-content: space-around;
  align-content: space-around;
  flex-wrap: wrap;
  color:#273049;
  font-size:1.2em;


`;


export const Unit = styled.div`
  box-shadow: 0 4px 8px rgba(0,0,0,0.25), 0 7px 7px rgba(0,0,0,0.22);
  text-align:center;
  height: ${props => (props.bool ? '97vh' : props.winheight/8.8)};
  width: ${props => (props.bool ? '99%' : '29vw')};
  background: #efeffa;
  transition: all 300ms ease-in-out;
`;



export const Unitfull = styled.div`
  text-align:center;
  position: absolute;
  top: ${props => (props.bool ? '0' : props.unity)}px
  left: ${props => (props.bool ? '0px' : props.unitx)}
  height: ${props => (props.bool ? props.unitfullh : '4em')};
  width: ${props => (props.bool ? '99%' : '31vw')};
  padding-top: 1em;
  background: #fcfaff;
  transition: all 300ms ease-in-out;
  z-index: ${props => (props.bool ? '500' : null)};

`;

export const Unitfullanimaton = styled.div`
  text-align:center;
  position: absolute;
  top: ${props => (props.bool ? '0' : props.unity)}px
  left: ${props => (props.bool ? '0px' : props.unitx)}
  height: ${props => (props.bool ? props.unitfullh : '4em')};
  width: ${props => (props.bool ? '99%' : '31vw')};
  padding-top: 1em;
  background: white;
  transition: all 200ms ease-in-out;
  z-index: 10;

`;


export const Appmain =styled.div`
  margin: 0px;
  height: 100vh;
  width:100%;
  text-align: center;
  background: #b3c0c7;
`



export const Contentheader=styled.div`

    color:#1a1a46;
    font-weight: bold;
    font-family: cursive;
    width: 99%;
    justify-content:space-between;
    padding-right: 15px;
    z-index: 11;
    position: relative;
    top:-25;
    display: flex;

`;

export const Message = styled.div`
      height:20px;

`;

export const Unittext = styled.div`
    font-weight: bold;
    font-size: ${props=>props.winwidth/95}px;
    height:${props=>props.winheight/14}px;
    display:flex;
    align-items:center;
    justify-content:center;
    color: #08051f;


`;

//
export const UnittextOp = styled.div`

    font-size: ${props=>props.winwidth/99}px;
    color: #b6b7ba;
    padding-bottom:${props=>props.winheight/20}px;
`;

export const Titletext = styled.div`

    font-size: ${props=>props.winwidth/99}px;
    color: #0a123c;
`;
